
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import {SaleService} from "@/services/sale-service";
import {Sale} from "@/models/base";

export default Vue.extend({
	data(){
		return {
			saving: false,
			date: null as null | Date
		};
	},
	props: {
		sale: {
			type: Object as ()=>Sale,
			required: true,
		}
	},
	computed: {
		title():{toString():string}{
			return `${this.$ct("EditDeliveryDate")}`;
		},
		confirmText():TranslateResult{
			return this.$ct("common.confirm");
		},
	},
	watch: {
		sale: {
			immediate: true,
			handler(){
				this.date = this.sale.DeliveryDate;
			}
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async confirm(){
			if (this.saving) return;
			this.saving = true;
			try{
				let sale = await SaleService.setDeliveryDate(this.sale.ID, this.date);
				this.sale.DeliveryDate = sale.DeliveryDate;
				this.close();
			}catch(err){

			}
			this.saving = false;
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
